import React from 'react';

const CampaignDetailModal = ({ campaign, onClose }) => {
  const [showInfluencerModal, setShowInfluencerModal] = React.useState(false);

  if (!campaign) return null;

  let influencerInfo = null;
  if (campaign && campaign.influencer_info) {
    if (typeof campaign.influencer_info === 'string') {
      try {
        influencerInfo = JSON.parse(campaign.influencer_info);
      } catch (e) {
        influencerInfo = campaign.influencer_info;
      }
    } else {
      influencerInfo = campaign.influencer_info;
    }
  }
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-2xl shadow-lg rounded-md bg-white">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-gray-900">Campaign Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-4">
          <div><strong>Influencer:</strong> {campaign.influencer_name}</div>
          <div><strong>Product:</strong> {campaign.product}</div>
          <div><strong>Platform:</strong> {campaign.platform}</div>
          <div><strong>Date:</strong> {campaign.date}</div>
          <div><strong>Team Members:</strong> {
            campaign.teamMembers && campaign.teamMembers.length > 0
              ? campaign.teamMembers.join(', ')
              : (campaign.team_member ? campaign.team_member : 'N/A')
          }</div>
          <div><strong>Amount:</strong> ₹{campaign.amount}</div>
          <div><strong>Views:</strong> {campaign.views}</div>
          <div><strong>Likes:</strong> {campaign.likes}</div>
          <div><strong>Comments:</strong> {campaign.comments}</div>
          <div><strong>Shares:</strong> {campaign.shares}</div>
          <div><strong>Reposts:</strong> {campaign.reposts}</div>
          <div><strong>Caption:</strong> <span className="whitespace-pre-wrap">{campaign.caption}</span></div>
          <div><strong>Post Link:</strong> {campaign.post_link ? <a href={campaign.post_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Open</a> : 'N/A'}</div>
          <div><strong>Video URL:</strong> {campaign.video_url ? <a href={campaign.video_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Open</a> : 'N/A'}</div>
          <div>
            <strong>Influencer Info:</strong>
            {influencerInfo ? (
              <button
                onClick={() => setShowInfluencerModal(true)}
                className="inline-flex items-center justify-center w-8 h-8 bg-purple-100 hover:bg-purple-200 text-purple-600 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ml-2"
                title="View influencer info"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
              </button>
            ) : (
              <span className="text-gray-400 text-xs ml-2">No info</span>
            )}
          </div>
          {/* Add more fields as needed */}
        </div>
        {showInfluencerModal && influencerInfo && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
            <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">Influencer Info</h3>
                <button
                  onClick={() => setShowInfluencerModal(false)}
                  className="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="mt-2 px-7 py-3">
                <pre className="text-sm text-gray-500 whitespace-pre-wrap max-h-96 overflow-y-auto">
                  {typeof influencerInfo === 'object' ? JSON.stringify(influencerInfo, null, 2) : influencerInfo}
                </pre>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  onClick={() => setShowInfluencerModal(false)}
                  className="px-4 py-2 bg-purple-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-purple-500"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CampaignDetailModal;
